<script setup lang="ts">
defineProps<{ event: EventCard }>();
</script>

<template>
  <NuxtLink :to="event.slug.full" class="group min-h-44 w-90 max-w-65 rounded-2xl p-4 pb-0 no-underline hover:bg-seagreen-20 sm:max-w-90">
    <div class="border-l border-dotted border-green-50 p-4 pb-12 text-green-50 group-hover:ml-px group-hover:border-0">
      <UiCommonsTag :event="event" />
      <CardsEventTitle
        :event="event"
        tag="h3"
        class="mb-4 mt-2"
      />
      <CardsEventDates :event="event" data-cell />
      <CardsEventLocation :event="event" data-cell />
      <CardsEventExternalSite :event="event" data-cell />
    </div>
  </NuxtLink>
</template>

<style scoped>
[data-cell] {
  display: grid;
  grid-template-columns: 1fr 7fr;
  align-items: start;
}
</style>
